import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';
import Settings from './Settings';
import {IconTransform, IconArrowCircle,IconArrow} from './Icons';
import TransformsBody from './TransformsBody';


@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class Transforms extends Component{

  @observable trans = {

  };


  constructor(props) {

    super(props);

    this.trans = this.props.dictionaryStorage.getCurrentLangDict;

    let scope = this;

  }


  render() {

    const t = this.t;

    return (
      <div className="bf-tools js-tools js-tools-open js-actions-area">
      <h6 className="tools-title js-tools-on-off"><IconTransform/>{t('Transforms')}</h6>
        <span className="tools-on-off js-tools-on-off">
          <IconArrow/>
        </span>
        <div className="Transforms-container">
          {
            ( !Settings.getSettingsIsActive )
            &&
            <div className="UniversalPrevent"></div>
          }
        <TransformsBody
         dictionaryStorage={ this.props.dictionaryStorage }
        />
        </div>
    </div>
    );


   // ReactDOM.render(dom, document.getElementById('transforms'));


  }


}


